module.exports = __webpack_public_path__ + "img/branch_thailand.6d9baf48.png";